import { createContext } from 'react';
import { Goal } from 'shared/types/goal';

export type GoalMetricsFormContextProps = {
  onOpenMetricsForm: (goal: Goal) => void;
};

export const GoalMetricsFormContext =
  createContext<GoalMetricsFormContextProps>({
    onOpenMetricsForm: () => {},
  });
